/* wc-meal-builder.js — live custom-meal nutrition for the shopapps/Bold builder.
   Pure core (sum + FDA round) is node-testable via tests/wc-meal-builder.test.js.
   FDA rules ported verbatim from app/Actions/Labels/Concerns/ExtractsRecipalNutrition.php
   in the wc-cooklist repo; Math.round matches PHP round() for non-negative values.
   Canonical copy: docs/shopify-theme/wc-meal-builder.js in the wc-cooklist repo. */
(function () {
  'use strict';

  function roundCalories(v) {
    if (v < 5) { return 0; }
    if (v <= 50) { return Math.round(v / 5) * 5; }
    return Math.round(v / 10) * 10;
  }
  function roundFat(v) {
    if (v < 0.5) { return 0; }
    if (v <= 5) { return Math.round(v * 2) / 2; }
    return Math.round(v);
  }
  function roundGrams(v) {
    if (v < 0.5) { return 0; }
    return Math.round(v);
  }
  function roundSodium(v) {
    if (v < 5) { return 0; }
    if (v <= 140) { return Math.round(v / 5) * 5; }
    return Math.round(v / 10) * 10;
  }

  // Sum raw macros for the selected component keys. Unknown keys (navigation,
  // "No X") are ignored; {has_recipe:false} components increment notCounted.
  function wcMealTotal(selectedKeys, map) {
    var raw = { calories: 0, protein_g: 0, carbs_g: 0, fat_g: 0, fiber_g: 0, sugar_g: 0, sodium_mg: 0 };
    var notCounted = 0;
    for (var i = 0; i < selectedKeys.length; i++) {
      var entry = map[selectedKeys[i]];
      if (!entry) { continue; }
      if (entry.has_recipe === false) { notCounted++; continue; }
      raw.calories += entry.calories || 0;
      raw.protein_g += entry.protein_g || 0;
      raw.carbs_g += entry.carbs_g || 0;
      raw.fat_g += entry.fat_g || 0;
      raw.fiber_g += entry.fiber_g || 0;
      raw.sugar_g += entry.sugar_g || 0;
      raw.sodium_mg += entry.sodium_mg || 0;
    }
    return { raw: raw, notCounted: notCounted };
  }

  // FDA-round the summed raw totals once.
  function wcFdaRound(raw) {
    return {
      calories: roundCalories(raw.calories),
      protein_g: roundGrams(raw.protein_g),
      carbs_g: roundGrams(raw.carbs_g),
      fat_g: roundFat(raw.fat_g),
      fiber_g: roundGrams(raw.fiber_g),
      sugar_g: roundGrams(raw.sugar_g),
      sodium_mg: roundSodium(raw.sodium_mg)
    };
  }

  var api = { wcMealTotal: wcMealTotal, wcFdaRound: wcFdaRound };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof window !== 'undefined') { window.WCMealBuilder = api; }

  // Browser-only DOM glue below; skipped under Node (where the pure core is tested).
  if (typeof document === 'undefined') { return; }

  function scope() { return document.querySelector('form[action*="/cart/add"]') || document; }

  // Read each builder selection's EFFECTIVE value as "{public_name}|{value}" keys.
  function readSelections() {
    var pairs = [];
    var inputs = scope().querySelectorAll('[name^="properties["]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var name = el.getAttribute('name');       // e.g. properties[Grilled Chicken Ounces]
      var prop = name.slice(11, -1);            // strip "properties[" (11 chars) and trailing "]"
      if (prop.charAt(0) === '_') { continue; } // Bold internals: properties[_*]
      var type = (el.type || '').toLowerCase();
      var val;
      if (type === 'radio' || type === 'checkbox') {
        if (!el.checked) { continue; }
        val = el.value;
      } else {
        val = el.value;                         // hidden (swatch target), select, text
      }
      if (val == null || val === '') { continue; }
      pairs.push(prop + '|' + val);
    }
    return pairs;
  }

  var mapEl = document.querySelector('[data-wc-meal-components]');
  if (!mapEl) { return; }
  var map;
  try { map = (JSON.parse(mapEl.textContent) || {}).components || {}; }
  catch (e) { return; }

  function fill(rounded, notCounted) {
    var nodes = document.querySelectorAll('[data-wc-mb]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var key = el.getAttribute('data-wc-mb');
      var unit = el.getAttribute('data-wc-unit') || '';
      var v = rounded[key];
      el.textContent = (v == null ? 0 : v) + unit;
    }
    var note = document.querySelector('[data-wc-mb-note]');
    if (note) { note.hidden = !(notCounted > 0); }
  }

  var lastSig = null;
  function render() {
    try {
      var keys = readSelections();
      var sig = keys.join('~');
      if (sig === lastSig) { return; }
      lastSig = sig;
      var total = wcMealTotal(keys, map);
      fill(wcFdaRound(total.raw), total.notCounted);
    } catch (e) { /* leave displays unchanged; never break the page */ }
  }

  // Flag-gated live self-test: append ?wc_selftest=1 to the product URL.
  function runSelfTest() {
    var t1 = wcFdaRound({ calories: 112.15, protein_g: 18.55, carbs_g: 0.43, fat_g: 3.89, fiber_g: 0.09, sugar_g: 0.07, sodium_mg: 54.86 });
    console.assert(t1.calories === 110 && t1.protein_g === 19 && t1.carbs_g === 0 && t1.fat_g === 4 && t1.sodium_mg === 55, 'wc_selftest FDA round', t1);
    var t2 = wcMealTotal(['A|x', 'B|y', 'Nope|z'], { 'A|x': { calories: 10, protein_g: 1, carbs_g: 2, fat_g: 0.3, fiber_g: 0, sugar_g: 0, sodium_mg: 4 }, 'B|y': { has_recipe: false } });
    console.assert(t2.raw.calories === 10 && t2.notCounted === 1, 'wc_selftest sum/notCounted/unknown', t2);
    console.log('[wc-meal-builder] self-test complete');
  }

  // The mini total bar is fixed to the viewport bottom but shown only once the
  // full grid has scrolled out of view (it's redundant while the grid is visible).
  // position:fixed (not sticky) so a mobile wrapper's overflow can't clip it.
  function setupStickyBar() {
    var bar = document.querySelector('[data-wc-mb-bar]');
    var grid = document.querySelector('[data-wc-mb-grid]');
    if (!bar || !grid) { return; }
    // Re-root to <body> so no ancestor transform/filter can trap position:fixed
    // (a common cause of a fixed bar refusing to stick on mobile drawer themes).
    if (bar.parentElement !== document.body) { document.body.appendChild(bar); }
    function setVisible(visible) {
      bar.classList.toggle('wc-mb-bar--visible', visible);
      document.body.style.paddingBottom = visible ? (bar.offsetHeight + 'px') : '';
    }
    setVisible(false);
    if (typeof IntersectionObserver === 'undefined') { setVisible(true); return; }
    var io = new IntersectionObserver(function (entries) {
      setVisible(!entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(grid);
  }

  function start() {
    render();
    setupStickyBar();
    // Safety net: Bold updates properties[...] without a reliable native/jQuery
    // change event (same reason wc-nutrition.liquid polls the variant id — 7b4297a).
    setInterval(render, 200);
    if (window.jQuery) { window.jQuery(document).on('change', 'form[action*="/cart/add"]', render); }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], [data-product-options], .option-selectors')) { render(); }
    });
    if (window.location && String(window.location.search).indexOf('wc_selftest') !== -1) { runSelfTest(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
